import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../libs/core/axios-base-query";


export const appApi = createApi({
  reducerPath: "appApi",
  baseQuery: axiosBaseQuery({ baseUrl: "https://api.diasporanexus.org/api" }),
  // baseQuery: axiosBaseQuery({ baseUrl: "http://192.168.247.115:8001/api" }),
  tagTypes: [
    "User",
    "UnitTypes",
    "Blogs",
    "Teams",
    "Subscribers",
    "Testimonials",
    "Partners",
    "dashboardSummary",
    "Messages",
    "Newsletter",
    "Galleries",
    "Categories",
    "Programs",
    "Impacts",
    "Vacancies",
    "Volunteers",
    "CSOMembers",
    "ResourceDocuments"
  ],
  endpoints: () => ({}),
});
